<template>
  <div class="bg-f3f4f7 h-100" v-loading.body="fullscreenLoading">
    <div class="flex-column flex-1" v-if="materialDetail.length>0">
      <div class="flex align-center bg-ff">
        <div class="mlr-10 mtb-5" v-for="(item, index) in materialDetail" :key="index">
          <a href="javascript:void (0)" @click="clickA(item.id, index)" class="flex align-center cursor">
            <div class="mr-5" :class="index === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{item.name}}</div>
          </a>
        </div>
      </div>
      <div class="flex" v-if="materialDetail.length>0">
        <div class="flex align-center mr-5 btn-24-bd-30313a mt-10" @click="changeStstus(2)" v-if="permission.includes('auditLock')">
          <img src="/static/images/suoding.png" class="icon-14 mr-5" alt="">
          <div>审核锁定</div>
        </div>
        <div class="flex align-center mr-5 btn-24-bd-30313a mt-10" @click="changeStstus(1)" v-if="permission.includes('unlock')">
          <img src="/static/images/jiesuo.png" class="icon-14 mr-5" alt="">
          <div>解除锁定</div>
        </div>
      </div>
      <div class="flex-1 flex-column editInfo h-100 mt-10">
        <div class="flex-1 h-100" ref="editInfo">
          <el-scrollbar style="height: 100%;" class="hide-x">
            <div class="main" id="scrollBody">
              <div class="infoItem mb-20" :id="item.id" v-for="(item, index) in materialDetail" :key="index">
                <div class="text-left mb-5"><button class="btn-20-bg-3d3e46">{{item.name}}</button></div>
                <div style="height: 300px">
                  <erp-table :confirm-material="1" :is-edit="true" ref="erpTable" :loading="loading" :table-footer="tableFooter" btn-show-key="status" :table-data="item.budgetContentList" :column-data="columnData" @on-confirmation="onConfirmation" @on-confirm="onConfirm" @on-replace="onReplace" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <!--<el-main v-else class="flex h-100">-->
      <!--<div class="text-center">-->
        <!--<div class="flex justify-center"><img src="/static/images/tip.png" class="icon-50 mb-20" alt=""></div>-->
        <!--<div class="font-12-ff5555">注意：此客户还没有材料确认相关信息！</div>-->
      <!--</div>-->
    <!--</el-main>-->
    <add-materialy ref="addMaterialy" :budgetType="1" @add-material="addMaterial"></add-materialy>
  </div>
</template>

<script>
import ErpTable from '../../../components/ErpTable'
import AddMaterialy from '../enterRoomItem/AddMaterialy'
export default {
  name: 'confirmMaterial',
  components: {ErpTable, AddMaterialy},
  props: ['budgetGroup', 'info', 'permission'],
  data () {
    return {
      budgetId: null,
      tabIndex: 0,
      loading: true,
      tableFooter: [
        {
          columns: ['budgetNumber', 'increaseDecrease', 'settlementNumber', 'checkNumber', 'actualQuantity', 'budgetClientSum', 'settlementClientSum'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'selection',
          width: '50'
        }, {
          type: 'index',
          title: '序号',
          width: '50'
        }, {
          field: 'operate',
          title: '操作',
          width: '120',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '确认',
            methodName: 'on-confirm',
            type: 'btn',
            showStatus: -1
          }, {
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '重确认',
            methodName: 'on-confirmation',
            showStatus: 2
          }, {
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '替换',
            methodName: 'on-replace',
            type: 'btn'
          }]
        }, {
          field: 'materialId',
          title: 'id',
          width: '40'
        }, {
          field: 'name',
          title: '材料名称',
          width: '360'
        }, {
          field: 'status',
          title: '状态',
          width: '80',
          editType: 'select',
          editRender: {
            name: 'select', // 编辑框为下拉框
            options: [
              {
                value: -1,
                label: '未确认'
              },
              {
                value: 2,
                label: '已确认'
              },
              {
                value: 1,
                label: '已锁定'
              }
            ]
          },
          formatter: 'toStatus'
        }, {
          field: 'specialItem',
          title: '特项',
          width: '50'
        }, {
          field: 'unit',
          title: '单位',
          width: '55'
        }, {
          field: 'priceType',
          title: '价格类型',
          width: '80'
        }, {
          field: 'budgetNumber',
          title: '预算量',
          width: '80'
        }, {
          field: 'increaseDecrease',
          title: '增减量',
          width: '80'
        }, {
          field: 'settlementNumber',
          title: '结算量',
          width: '80'
        }, {
          field: 'clientPrice',
          title: '单价',
          width: '60'
        }, {
          field: 'checkNumber',
          title: '核算量',
          width: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'actualQuantity',
          title: '实际用量',
          width: '100'
        }, {
          field: 'budgetClientSum',
          title: '预算合价',
          width: '100'
        }, {
          field: 'settlementClientSum',
          title: '结算合价',
          width: '100'
        }, {
          field: 'subitem',
          title: '项目备注',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      materialDetail: [],
      replaceId: '',
      replaceStatus: null,
      replaceLocked: null,
      replaceConfirm: null,
      fullscreenLoading: false
    }
  },
  watch: {
    budgetGroup (newVal) {
      this.budgetGroup = newVal
      if (newVal.id) {
        this.fullscreenLoading = true
        this.budgetId = newVal.id
        this.status = newVal.status
        this.getMaterial()
      } else {
        this.materialDetail = []
      }
    },
    materialDetail (newVal) {
      this.materialDetail = newVal
    }
  },
  created () {
    this.getPermission()
    this.getMaterial()
  },
  mounted () {
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    onReplace (row, column, colName) {
      if (row.isLocked === 2) {
        this.$message({
          message: '已审核锁定，不能替换',
          type: 'warning'
        })
      } else {
        this.$refs.addMaterialy.addMaterialyVisible = true
        this.replaceId = row.id
        this.replaceStatus = row.status
        this.replaceLocked = row.isLocked
        this.replaceConfirm = row.isConfirm
      }
    },
    addMaterial (data, priceList, rebateFlag) {
      var reg = new RegExp('null', 'g')
      let params = {
        type: 2,
        budgetRoomId: this.budgetRoomId,
        materialId: data.id,
        priceId: priceList.id,
        priceType: priceList.name,
        costPrice: data[priceList.costPriceField],
        unit: data.salesUnit,
        ...data,
        name: (data.brand + ' ' + data.name + ' ' + data.standard + ' ' + data.model).replace(reg, ''),
        rebateFlag: rebateFlag
      }
      if (this.isGive === 1) {
        params.clientPrice = 0
      } else {
        params.clientPrice = data[priceList.customerPriceField] === -1 ? 0 : data[priceList.customerPriceField]
      }
      params.id = this.replaceId
      params.budgetId = this.budgetId
      this.axios.post('budgetContent/modify', params).then(res => {
        if (res.data.success) {
          this.addMaterialyVisible = false
          this.getMaterial()
          let list = this.materialDetail
          for (let i = 0; i < list.length; i++) {
            if (res.data.data.budgetId === list[i].budgetId) {
              for (let j = 0; j < list[i].budgetContentList.length; j++) {
                if (list[i].budgetContentList[j].id === res.data.data.id) {
                  list[i].budgetContentList.splice(j, 1, res.data.data)
                  list[i].budgetContentList[j].status = this.replaceStatus
                  list[i].budgetContentList[j].isLocked = this.replaceLocked
                  list[i].budgetContentList[j].isConfirm = this.replaceConfirm
                }
              }
            }
          }
          this.materialDetail = list
          this.$message({
            message: '替换材料成功',
            type: 'success'
          })
        }
      })
    },
    getMaterial () {
      // this.budgetId = this.budgetGroup.id
      if (this.budgetId) {
        this.materialDetail = []
        let params = {
          budgetId: this.budgetId
        }
        this.axios.post('budgetRoom/findMaterial', params).then(res => {
          if (res.data.success) {
            this.loading = false
            this.fullscreenLoading = false
            res.data.data.forEach(item => {
              item.budgetContentList.forEach(i => {
                if (i.isLocked === 2) {
                  i.status = 1
                } else {
                  if (i.isConfirm === 2) {
                    i.status = 2
                  } else {
                    i.status = -1
                  }
                }
                if (this.status === 2 || !this.permission.includes('checkComputation')) {
                  i.unEditable = 'checkNumber'
                } else if (this.permission.includes('checkComputation')) {
                  i.unEditable = ''
                }
              })
            })
            this.materialDetail = res.data.data
          }
        })
      }
    },
    changeStstus (isLocked) {
      let ids = ''
      let customerArr = []
      for (let i = 0; i < this.materialDetail.length; i++) {
        if (this.$refs.erpTable[i].getSelectEvent().length > 0) {
          customerArr = customerArr.concat(this.$refs.erpTable[i].getSelectEvent())
          let flag = true
          customerArr.forEach(item => {
            if (isLocked === 1) {
              if (item.actualQuantity == null || item.actualQuantity === 0) {
                if (ids) {
                  ids = ids + ',' + item.id
                } else {
                  ids = item.id
                }
              } else {
                this.$message({
                  message: `该材料已下单`,
                  type: 'warning'
                })
              }
            } else {
              if (item.businessId) {
                if (ids) {
                  ids = ids + ',' + item.id
                } else {
                  ids = item.id
                }
              } else {
                if (flag) {
                  this.$message({
                    message: '材料没有供应商找材料部协调后重试',
                    type: 'warning',
                    duration: 1000,
                    offset: 200
                  })
                  flag = false
                }
              }
            }
          })
        }
      }
      let bugetContentArr = ids.split(',')
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择材料`,
          type: 'warning'
        })
      } else {
        if (ids) {
          let params = {
            ids: ids,
            isLocked: isLocked
          }
          this.axios.post('budgetContent/changeLock', params).then(res => {
            if (res.data.success) {
              let list = this.materialDetail
              for (let i = 0; i < list.length; i++) {
                for (let k = 0; k < customerArr.length; k++) {
                  if (customerArr[k].budgetId === list[i].budgetId) {
                    for (let j = 0; j < list[i].budgetContentList.length; j++) {
                      for (let m = 0; m < bugetContentArr.length; m++) {
                        if (list[i].budgetContentList[j].id === bugetContentArr[m]) {
                          list[i].budgetContentList[j].isLocked = res.data.data.isLocked
                          list[i].budgetContentList[j].isConfirm = res.data.data.isConfirm
                          if (list[i].budgetContentList[j].isLocked === 2) {
                            list[i].budgetContentList[j].status = 1
                          } else {
                            if (list[i].budgetContentList[j].isConfirm === 2) {
                              list[i].budgetContentList[j].status = 2
                            } else {
                              list[i].budgetContentList[j].status = -1
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              // for (let i = 0; i < list.length; i++) {
              //   for (let k = 0; k < customerArr.length; k++) {
              //     if (customerArr[k].budgetId === list[i].budgetId) {
              //       for (let j = 0; j < list[i].budgetContentList.length; j++) {
              //         console.log(bugetContentArr.indexOf(list[i].budgetContentList[j].id))
              //         console.log(list[i].budgetContentList[j].id)
              //         if (bugetContentArr.indexOf(list[i].budgetContentList[j].id > -1) && list[i].budgetContentList[j].id === customerArr[k].id) {
              //           console.log(6666)
              //           list[i].budgetContentList[j].isLocked = res.data.data.isLocked
              //           list[i].budgetContentList[j].isConfirm = res.data.data.isConfirm
              //           if (list[i].budgetContentList[j].isLocked === 2) {
              //             list[i].budgetContentList[j].status = 1
              //           } else {
              //             if (list[i].budgetContentList[j].isConfirm === 2) {
              //               list[i].budgetContentList[j].status = 2
              //             } else {
              //               list[i].budgetContentList[j].status = -1
              //             }
              //           }
              //         }
              //       }
              //     }
              //   }
              // }
              this.materialDetail = list
              for (let i = 0; i < this.materialDetail.length; i++) {
                this.$refs.erpTable[i].setAllSelection(false)
              }
              // this.getMaterial()
              this.$message.success('状态改变成功')
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }
      }
    },
    onConfirm (row) {
      if (row.businessId) {
        let params = {
          id: row.id,
          isLocked: row.isLocked,
          isConfirm: 2
        }
        this.axios.post('budgetContent/changeLock', params).then(res => {
          if (res.data.success) {
            this.$message.success('状态改变成功')
            // this.getMaterial()
            let list = this.materialDetail
            for (let i = 0; i < list.length; i++) {
              if (row.budgetId === list[i].budgetId) {
                for (let j = 0; j < list[i].budgetContentList.length; j++) {
                  if (list[i].budgetContentList[j].id === row.id) {
                    list[i].budgetContentList[j].isConfirm = 2
                    if (list[i].budgetContentList[j].isLocked === 2) {
                      list[i].budgetContentList[j].status = 1
                    } else {
                      if (list[i].budgetContentList[j].isConfirm === 2) {
                        list[i].budgetContentList[j].status = 2
                      } else {
                        list[i].budgetContentList[j].status = -1
                      }
                    }
                  }
                }
              }
            }
            this.materialDetail = list
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else {
        this.$message({
          message: '此材料没有供应商找材料部协调后重试',
          type: 'warning',
          duration: 1000,
          offset: 200
        })
      }
    },
    onConfirmation (row) {
      if (row.businessId) {
        let params = {
          id: row.id,
          isLocked: row.isLocked,
          isConfirm: 1
        }
        this.axios.post('budgetContent/changeLock', params).then(res => {
          if (res.data.success) {
            this.$message.success('状态改变成功')
            // this.getMaterial()
            let list = this.materialDetail
            for (let i = 0; i < list.length; i++) {
              if (row.budgetId === list[i].budgetId) {
                for (let j = 0; j < list[i].budgetContentList.length; j++) {
                  if (list[i].budgetContentList[j].id === row.id) {
                    list[i].budgetContentList[j].isConfirm = 1
                    if (list[i].budgetContentList[j].isLocked === 2) {
                      list[i].budgetContentList[j].status = 1
                    } else {
                      if (list[i].budgetContentList[j].isConfirm === 2) {
                        list[i].budgetContentList[j].status = 2
                      } else {
                        list[i].budgetContentList[j].status = -1
                      }
                    }
                  }
                }
              }
            }
            this.materialDetail = list
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else {
        this.$message({
          message: '此材料没有供应商找材料部协调后重试',
          type: 'warning',
          duration: 1000,
          offset: 200
        })
      }
    },
    onModifyRow (row) {
      let params = {
        ...row
      }
      this.axios.post('budgetContent/modify', params).then(res => {
        if (res.data.success) {
          // this.getMaterial()
          this.$message.success('修改成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    clickA (id, index) {
      let item = document.getElementById(id.replace('#', ''))
      this.tabIndex = index
      item.scrollIntoView({block: 'start', behavior: 'smooth'})
      return false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/customer/budgetItem/confirmMaterial.vue